import { all, takeLatest, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../../admincore'

import { getDetailRule } from '../../../api'
import actions, { load } from './actions'

// const getCompanySelect = state => state.companySelect

let cachedParams = null

function* LOAD({ payload: { id } }) {
  cachedParams = id
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }
  yield put(request(getDetailRule(companySelect, id), actions.LOAD))
}

function* REFRESH() {
  if (cachedParams) {
    yield put(load(cachedParams))
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actions.LOAD, LOAD), takeEvery('rules/update/success', REFRESH)])
}
